import { HttpRequest } from '@angular/common/http';
import { FuseMockApiReplyCallback } from '@fuse/lib/mock-api/mock-api.types';
import { Observable, of, take, throwError } from 'rxjs';

export class FuseMockApiHandler {
    public request!: HttpRequest<any>;
    public urlParams!: { [key: string]: string };

    // Private
    private replyCallback: FuseMockApiReplyCallback = undefined;
    private replyLimit = 0;
    private repliedCount = 0;

    /**
     * Constructor
     */
    constructor(
        public url: string,
        public delay?: number
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for response callback
     */
    public get response(): Observable<any> {
        // If the execution limit has been reached, throw an error
        if (this.replyLimit > 0 && this.replyLimit <= this.repliedCount) {
            return throwError('Execution limit has been reached!');
        }

        // If the response callback has not been set, throw an error
        if (!this.replyCallback) {
            return throwError('Response callback function does not exist!');
        }

        // If the request has not been set, throw an error
        if (!this.request) {
            return throwError('Request does not exist!');
        }

        // Increase the replied count
        this.repliedCount++;

        // Execute the reply callback
        const replyResult = this.replyCallback({
            request: this.request,
            urlParams: this.urlParams,
        });

        // If the result of the reply callback is an observable...
        if (replyResult instanceof Observable) {
            // Return the result as it is
            return replyResult.pipe(take(1));
        }

        // Otherwise, return the result as an observable
        return of(replyResult).pipe(take(1));
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Reply
     *
     * @param callback
     */
    public reply(callback: FuseMockApiReplyCallback): void {
        // Store the reply
        this.replyCallback = callback;
    }

    /**
     * Reply count
     *
     * @param count
     */
    public replyCount(count: number): void {
        // Store the reply count
        this.replyLimit = count;
    }
}
